// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  eurogerm: false,
  hmr: false,
  apiUrl: "https://ec-api04.endepro.net/",
  webSocketURL: "wss://ecws02.endepro.net:443/",
  webSocketLocalURL: 'wss://127.0.0.1:7681/',
  versionCheckURL: `https://${window.location.host}/version.json`,
  serverAuthUrl: "https://econnect-is-sts.endepro.net",
  defaultScope: "econnect-api",
  screenIP: "127.0.0.1:7681/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
